import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import styles from "./RadioInput.scss";

const RadioInput = ({
	wrapperClassName,
	labelClassName,
	inputClassName,
	label,
	id,
	name,
	value,
	selected,
	error,
	onChange
}) => {
	const handleOnChange = event => {
		onChange(event.target.value);
	};

	return (
		<label
			htmlFor={id}
			className={cx(styles.wrapper, wrapperClassName, error && styles.error)}>
			<input
				className={cx(styles.input, inputClassName)}
				type="radio"
				id={id}
				name={name}
				value={value}
				checked={selected}
				onChange={handleOnChange}
			/>
			<span />
			<span className={cx(styles.label, labelClassName)}>{label}</span>
		</label>
	);
};

RadioInput.propTypes = {
	wrapperClassName: PropTypes.string,
	labelClassName: PropTypes.string,
	inputClassName: PropTypes.string,
	label: PropTypes.string.isRequired,
	id: PropTypes.string.isRequired,
	name: PropTypes.string.isRequired,
	value: PropTypes.string.isRequired,
	selected: PropTypes.bool,
	error: PropTypes.bool,
	onChange: PropTypes.func
};

RadioInput.defaultProps = {
	wrapperClassName: undefined,
	labelClassName: undefined,
	inputClassName: undefined,
	selected: false,
	error: false,
	onChange: () => {}
};

export default RadioInput;
export { RadioInput };
